class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.openTimer = null;
    this.closeTimer = null;

    this.addEventListener('mouseenter', this.onPointerEnter.bind(this));
    this.addEventListener('mouseleave', this.onPointerLeave.bind(this));
    this.addEventListener('focusin', this.onFocusIn.bind(this));
  }

  onPointerEnter() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    clearTimeout(this.closeTimer);
    this.openTimer = setTimeout(() => this.open(), 150);
  }

  onPointerLeave() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    clearTimeout(this.openTimer);
    this.closeTimer = setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 150);
  }

  onFocusIn(event) {
    if (event.target === this.summary) this.open();
  }

  open() {
    clearTimeout(this.closeTimer);
    if (this.mainDetailsToggle.hasAttribute('open')) return;

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);

class MobileMenuFilter extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector(':scope > .mobile-submenu-navigation__search [data-navigation-filter-input]');
    this.items = Array.from(this.querySelectorAll(':scope > .mobile-submenu-navigation__list > [data-navigation-filter-item]'));
    this.emptyState = this.querySelector(':scope > [data-navigation-filter-empty]');

    if (this.input) this.input.addEventListener('input', this.onInput.bind(this));
  }

  onInput() {
    const query = this.input.value.trim().toLocaleLowerCase();
    let visibleItems = 0;

    this.items.forEach((item) => {
      const filterText = (item.dataset?.filterText || item.textContent || '').toLocaleLowerCase();
      item.hidden = query !== '' && !filterText.includes(query);
      if (!item.hidden) visibleItems += 1;
    });

    if (this.emptyState) this.emptyState.hidden = visibleItems !== 0;
  }
}

customElements.define('mobile-menu-filter', MobileMenuFilter);
